import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  CHAS_DENTAL_SUBSIDY_BALANCE_PATH,
  CHAS_PATH,
  CHAS_SUBSIDY_BALANCE_PATH,
  CHAS_TRANSACTION_HISTORY_PATH,
  CHAS_VISIT_BALANCE_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const CHASPage = lazy(() => import('./pages/CHASPage/CHASPage'));
const SubsidyBalancePage = lazy(() => import('./pages/SubsidyBalancePage/SubsidyBalancePage'));
const VisitBalancePage = lazy(() => import('./pages/VisitBalancePage/VisitBalancePage'));
const DentalSubsidyBalancePage = lazy(() => import('./pages/DentalSubsidyBalancePage/DentalSubsidyBalancePage'));
const TransactionHistoryPage = lazy(() => import('./pages/TransactionHistoryPage/TransactionHistoryPage'));

export const CHAS_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CHASPage />,
    displayTitle: () => 'My CHAS',
    pageType: PageType.PRIVATE,
    path: CHAS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.chas,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <SubsidyBalancePage />,
    displayTitle: () => 'View Subsidy Balance',
    pageType: PageType.PRIVATE,
    path: CHAS_SUBSIDY_BALANCE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.chas,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <VisitBalancePage />,
    displayTitle: () => 'View Visit Balance',
    pageType: PageType.PRIVATE,
    path: CHAS_VISIT_BALANCE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.chas,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <DentalSubsidyBalancePage />,
    displayTitle: () => 'View Subsidy Balance',
    pageType: PageType.PRIVATE,
    path: CHAS_DENTAL_SUBSIDY_BALANCE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.chas,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <TransactionHistoryPage />,
    displayTitle: () => 'Transaction History',
    pageType: PageType.PRIVATE,
    path: CHAS_TRANSACTION_HISTORY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.chas,
  },
];
